// extracted by mini-css-extract-plugin
export default {"container":"styles_container__1VS8M","footnote":"styles_footnote__Ttakk","grayText":"styles_grayText__u2Rlf"};